// MUI
import { Box, Stack, styled, Typography } from '@mui/material'
// Localization
import { t } from '$i18n'
import { CreateRoomFab } from '../create-room-fab'
import { ToolboxFab } from '$comp/_app/components/leftPanel/components/chat-list/components/toolbox-fab'

const EmptyChatListContainer = styled(Box)`
  padding: 12px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: white;
`

const EmptyListImage = styled('img')`
  margin: 20px;
  width: 148px;
  height: 148px;
`

const ArrowImage = styled('img')`
  position: absolute;
  width: 98px;
  height: 143px;
  bottom: 45px;
  left: 86px;
`

export function EmptyChatList() {
  return (
    <EmptyChatListContainer>
      <Stack alignItems="center">
        <EmptyListImage src="/assets/svg/empty-chat-list.svg" alt="new chat" />

        <Typography variant="subtitle1" sx={{ marginBottom: '5px' }}>
          {t('emptyChatList.title')}
        </Typography>

        <Typography variant="body2" color="semiBlack" align="center">
          {t('emptyChatList.description')}
        </Typography>
      </Stack>

      <ArrowImage src="/assets/svg/empty-chat-list-arrow.svg" alt="arrow" />
      <CreateRoomFab />
      <ToolboxFab />
    </EmptyChatListContainer>
  )
}
